import React from 'react';
import { Box, Typography, Grid, Chip } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { youtubeAPI } from '../../services/api';
import SectionTitle from '../crt/SectionTitle';
import Panel from '../crt/Panel';

const Recommendations: React.FC = () => {
  const { data: recs } = useQuery({
    queryKey: ['publish-recs', 90],
    queryFn: () => youtubeAPI.getPublishRecommendations(90, 5),
    staleTime: 60000,
  });
  const { data: titles } = useQuery({
    queryKey: ['title-thumb', 180],
    queryFn: () => youtubeAPI.getTitleThumbSuggestions(180),
    staleTime: 60000,
  });

  return (
    <Box>
      <SectionTitle>RECOMMENDATIONS</SectionTitle>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Panel label="BEST PUBLISH TIMES">
            <Box display="flex" flexWrap="wrap" gap={1}>
              {(recs?.slots || []).map((s: any, idx: number) => (
                <Chip key={idx} label={`${['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][s.weekday]} @ ${s.hour}:00`} />
              ))}
            </Box>
          </Panel>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Panel label="TITLE & THUMBNAIL SUGGESTIONS">
            <Box display="flex" flexDirection="column" gap={0.5}>
              {(titles?.suggestions || []).map((t: any, idx: number) => (
                <Typography key={idx} variant="body2">• [{t.type}] {t.text}</Typography>
              ))}
            </Box>
            {!titles?.suggestions?.length && (
              <Typography color="textSecondary">Suggestions will appear as data accumulates.</Typography>
            )}
          </Panel>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Recommendations;
